import { useCallback, useRef, useState } from 'react';
import FileSaver from 'file-saver';

interface Workbook {
  csv: {
    writeBuffer: () => Promise<ArrayBuffer>;
  };
}

interface ExportRef {
  exportGrid: () => void;
}

const useEMDashboardExport = () => {
  const [exportName, setExportName] = useState<string | null>(null);
  const exportRef = useRef<ExportRef | null>(null);

  const exportHandler = useCallback((name: string) => {
    setExportName(name);
    if (exportRef.current) {
      exportRef.current.exportGrid();
    }
  }, []);

  const onSave = useCallback(
    (workbook: Workbook) => {
      workbook.csv.writeBuffer().then(buffer => {
        FileSaver.saveAs(
          new Blob([buffer], { type: 'text/csv' }),
          `${exportName}.csv`
        );
      });
    },
    [exportName]
  );

  return { exportHandler, onSave, exportRef };
};

export default useEMDashboardExport;
